"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntuitRealmSchemaProperties = exports.IntuitRealmSchema = exports.RefundType = exports.AccountMapSchema = exports.FieldMapSchema = exports.IntuitTokenSchema = exports.IntuitQuickBooksCustomerInfoSchema = exports.IntuitQuickBooksInvoiceInfoSchema = exports.IntuitQuickBooksInvoiceInfoRecordSchema = exports.IntuitQuickBooksPackageInfoSchema = exports.IntuitQuickBooksPackageSkuSchema = exports.BaseOrganizationIntegrationSchema = exports.OrganizationIntegrationTypeSchema = exports.OrganizationIntegrationType = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
// Organization Integration Types
var OrganizationIntegrationType;
(function (OrganizationIntegrationType) {
    OrganizationIntegrationType["IntuitQuickBooks"] = "intuit_quickbooks";
})(OrganizationIntegrationType || (exports.OrganizationIntegrationType = OrganizationIntegrationType = {}));
// Create a Zod schema based on the TypeScript enum
exports.OrganizationIntegrationTypeSchema = zod_1.z.nativeEnum(OrganizationIntegrationType);
// Base Integration Schema not to be used directly
exports.BaseOrganizationIntegrationSchema = base_schema_1.BaseSchema.extend({
    name: zod_1.z.string().optional(),
    type: exports.OrganizationIntegrationTypeSchema,
    addedBy: zod_1.z.string(),
    updatedBy: zod_1.z.string().optional(),
    deletedBy: zod_1.z.string().optional(),
});
exports.IntuitQuickBooksPackageSkuSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.string());
// Zod schema to save on the invoice record
exports.IntuitQuickBooksPackageInfoSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    itemSku: exports.IntuitQuickBooksPackageSkuSchema,
    createdAt: zod_1.z.date().optional(),
    updatedAt: zod_1.z.date().optional(),
}));
exports.IntuitQuickBooksInvoiceInfoRecordSchema = zod_1.z.object({
    docNumber: zod_1.z.string().optional(),
    invoiceId: zod_1.z.string().optional(),
    paymentId: zod_1.z.string().optional(),
    createdAt: zod_1.z.date().optional(),
    updatedAt: zod_1.z.date().optional(),
});
// Zod schema to save on the invoice record
exports.IntuitQuickBooksInvoiceInfoSchema = zod_1.z.record(zod_1.z.string(), exports.IntuitQuickBooksInvoiceInfoRecordSchema);
// Zod schema to save on the client record
exports.IntuitQuickBooksCustomerInfoSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    customerId: zod_1.z.string(),
    createdAt: zod_1.z.date().optional(),
    updatedAt: zod_1.z.date().optional(),
}));
// Zod schema that matches the intuit type: Token
exports.IntuitTokenSchema = zod_1.z.object({
    access_token: zod_1.z.string(),
    refresh_token: zod_1.z.string(),
    expires_in: zod_1.z.number(),
    x_refresh_token_expires_in: zod_1.z.number(),
    token_type: zod_1.z.string(),
});
// Field Mapping
exports.FieldMapSchema = zod_1.z.object({
    localField: zod_1.z.string(),
    remoteField: zod_1.z.string(),
});
// Account Mapping
exports.AccountMapSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.object({
    debitAccountId: zod_1.z.string(),
    creditAccountId: zod_1.z.string(),
}));
var RefundType;
(function (RefundType) {
    RefundType["RefundReceipt"] = "refund_receipt";
    RefundType["Expense"] = "expense";
    RefundType["Both"] = "both";
})(RefundType || (exports.RefundType = RefundType = {}));
// Realms are the companies that the user has access to
exports.IntuitRealmSchema = exports.BaseOrganizationIntegrationSchema.extend({
    realmId: zod_1.z.string(),
    token: exports.IntuitTokenSchema.nullable(),
    tokenExpiresAt: zod_1.z.date().optional(),
    refreshTokenExpiresAt: zod_1.z.date().optional(),
    fieldMaps: zod_1.z.record(zod_1.z.string(), exports.FieldMapSchema).optional().nullable(),
    accountMaps: zod_1.z.record(zod_1.z.string(), exports.AccountMapSchema).optional().nullable(),
    enabledClientPush: zod_1.z.boolean().default(true),
    enabledClientPull: zod_1.z.boolean().default(false),
    refundType: zod_1.z.nativeEnum(RefundType).default(RefundType.RefundReceipt),
});
exports.IntuitRealmSchemaProperties = {
    collectionName: "integrations",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=intuit-realm.js.map